import React, { useState } from "react";
import OwnerBubble from "./OwnerBubble";

// The "Assign Owner" pop-up, shared by every Tasks tab. Tick to assign, untick
// to unassign; nothing is written until Save, which hands back the full set of
// chosen employee ids and leaves the request to the caller (a Personal or
// Corporate task PATCHes employee_ids; an Other task assigns and unassigns one
// person at a time).
export default function OwnerPickerModal({
  employees = [], initialIds = [], onSave, onClose, busy = false,
}) {
  const [selected, setSelected] = useState(() => initialIds.map(Number));

  const toggle = (id) =>
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]);

  const people = employees.filter((emp) => emp.is_active !== false);

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex", alignItems: "center", justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Assign Owner"
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: "#ffffff", borderRadius: 12, padding: "24px 28px",
          width: 420, maxHeight: "80vh", overflow: "auto",
          boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center",
                      justifyContent: "space-between", marginBottom: 20 }}>
          <h3 style={{ margin: 0, fontSize: 18, fontWeight: 600, color: "#323338" }}>
            Assign Owner
          </h3>
          <button
            onClick={onClose}
            aria-label="Close"
            style={{ background: "none", border: "none", cursor: "pointer",
                     padding: 4, display: "flex", color: "#676879" }}
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
              <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
            </svg>
          </button>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 20 }}>
          {people.map((emp) => {
            const id = Number(emp.id);
            const on = selected.includes(id);
            const name = emp.name || emp.full_name || emp.user?.username || "";
            return (
              <label
                key={emp.id}
                style={{
                  display: "flex", alignItems: "center", gap: 12, padding: 12,
                  border: on ? "2px solid #0073ea" : "1px solid #d0d4e4",
                  borderRadius: 8, backgroundColor: on ? "#e6f4ff" : "#ffffff",
                  cursor: "pointer",
                }}
              >
                <input type="checkbox" checked={on} onChange={() => toggle(id)}
                       aria-label={name}
                       style={{ cursor: "pointer" }} />
                <OwnerBubble owner={name} size={32} />
                <span style={{ fontSize: 14, fontWeight: 500, color: "#323338", flex: 1 }}>
                  {name}
                </span>
              </label>
            );
          })}
        </div>

        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <button
            onClick={onClose}
            style={{
              padding: "10px 20px", fontSize: 14, border: "1px solid #d0d4e4",
              borderRadius: 8, backgroundColor: "#ffffff", color: "#323338",
              cursor: "pointer", fontWeight: 500,
            }}
          >
            Cancel
          </button>
          <button
            onClick={() => onSave(selected)}
            disabled={busy}
            style={{
              padding: "10px 20px", fontSize: 14, border: "none", borderRadius: 8,
              backgroundColor: "#0073ea", color: "#ffffff", cursor: "pointer",
              fontWeight: 600, opacity: busy ? 0.6 : 1,
            }}
          >
            {busy ? "Saving…" : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}
